module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/finance/finance.component.css
// module id = ./src/app/web/game/management/business-units/finance/finance.component.css
// module chunks = main